// MELHORIA 13 — cobrança de cliente em cards parados (espelho do backend).
export const STATUS_COBRANCA_CLIENTE = ["demandas", "aguardando_cliente"];
export const SLA_COBRANCA_MS = 48 * 60 * 60 * 1000; // meta: 48h

export function ehColunaCobranca(status?: string | null): boolean {
  return !!status && STATUS_COBRANCA_CLIENTE.includes(status);
}

function inicioDeHoje(): number {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

/** true se já registraram cobrança HOJE (silencia o lembrete até amanhã). */
export function cobradoHoje(ultimaCobrancaEm?: string | null): boolean {
  return !!ultimaCobrancaEm && new Date(ultimaCobrancaEm).getTime() >= inicioDeHoje();
}

/** "há 5h" / "há 2d 3h" a partir de ms parado. */
export function tempoParadoLabel(ms: number): string {
  const h = Math.floor(ms / 3600000);
  if (h < 1) return "menos de 1h";
  if (h < 48) return `${h}h`;
  const d = Math.floor(h / 24);
  const resto = h % 24;
  return resto ? `${d}d ${resto}h` : `${d}d`;
}
